<template>
  <div class="divide-y divide-gray">
    <div class="text-center py-8">
      <h1 class="text-secondary text-xl font-medium my-auto">
        Hola, {{ getUserAuthenticated.name }}
      </h1>
      <h4 class="text-blue-900 font-light">
        Bienvenido a la plataforma de gestión Bildin
      </h4>
    </div>
    <div></div>
  </div>
  <div class="mt-20">
    <div
      class="flex flex-col md:flex-row justify-center text-center md:px-2 px-16"
    >
      <div class="xl:w-1/6 lg:w-1/4 md:w-1/2 w-full">
        <router-link
          v-if="allowModule($modules.TAREO)"
          :to="{ name: 'tasker-report' }"
          class="mx-2"
        >
          <div
            class="
              p-6
              px-8
              mx-2
              rounded-md
              shadow-lg
              hover:bg-primary
              text-primary
              hover:text-white
              welcome-card
            "
          >
            <div class="flex justify-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  opacity="0.12"
                  cx="28"
                  cy="28"
                  r="28"
                  fill="#0057FF"
                  class="w-circle"
                />
                <path
                  class="w-icon"
                  d="M40 36.209C39.9104 36.4179 39.8508 36.6269 39.7314 36.806C39.4627 37.2537 39.0149 37.4627 38.5075 37.4627C37.2537 37.4627 36 37.4925 34.7761 37.4627C33.8806 37.4627 33.2537 36.806 33.2537 35.9105C33.2537 35.4328 33.2537 34.9552 33.2537 34.4478C33.2537 34.3582 33.2239 34.2687 33.1642 34.209C32.3881 33.5821 31.6119 32.9851 30.8358 32.3582C30.806 32.3582 30.806 32.3284 30.7761 32.3284C30.7463 32.3284 30.7463 32.3582 30.7164 32.3582C30.4776 32.5373 30.5075 32.7164 30.6269 32.9552C31.2836 34.1194 31.0448 35.7612 30.1194 36.7164C29.6418 37.194 29.0746 37.4627 28.3881 37.4627C25.1343 37.4627 21.8806 37.4627 18.6269 37.4627C17.403 37.4627 16.388 36.5672 16.1194 35.2537C15.9403 34.3881 16.0298 33.5522 16.4776 32.7761C16.5075 32.7164 16.5373 32.6866 16.5672 32.597C16.0597 32.1791 16 31.6119 16 30.9851C16 29.7015 16 28.4179 16 27.1343C16 26.0896 16.6269 25.4627 17.6716 25.4627C18.1194 25.4627 18.5373 25.4627 19.0149 25.4627V25.1642V19.6716C19.0149 18.6269 19.6418 18 20.6866 18C21.8806 18 23.0448 18 24.2388 18C26.3284 18 27.9701 19.194 28.6567 21.194C29.1343 22.597 29.5821 24 30.0597 25.403C30.1194 25.5522 30.1791 25.6418 30.2985 25.7313C30.7463 26.0299 30.9851 26.4776 30.9851 27.0149C30.9851 27.5224 30.9851 28 30.9851 28.5075C30.9851 28.597 31.0149 28.6866 31.0746 28.7164C31.7612 29.2537 32.4478 29.791 33.1343 30.3582C33.1642 30.3881 33.194 30.3881 33.2537 30.4179C33.2537 30.2388 33.2537 30.0896 33.2537 29.9702C33.2836 29.2836 33.7015 28.7164 34.3284 28.5373C34.9552 28.3582 35.6418 28.5672 36 29.1642C36.5672 30.0597 37.1343 30.9851 37.7015 31.8806C38.3582 32.9254 39.0149 33.9403 39.6418 34.9851C39.791 35.194 39.8806 35.4627 40 35.7015V36.209ZM26.9254 25.4627C26.9254 25.4328 26.8955 25.3731 26.8955 25.3433C26.5373 24.2388 26.1791 23.1343 25.791 22.0299C25.5522 21.3433 25.0149 20.9851 24.2985 20.9851C23.6418 20.9851 22.9552 20.9851 22.2985 20.9851H22.0597V23.2239C22.6866 23.2537 23.194 23.4627 23.6119 23.8806C24.0299 24.2985 24.2687 24.8358 24.2985 25.4627H26.9254ZM20.5373 34.4776C20.5373 33.6418 19.8806 32.9851 19.0448 32.9851C18.2388 32.9851 17.5522 33.6418 17.5522 34.4776C17.5224 35.2836 18.2388 36 19.0448 36C19.8507 35.9702 20.5373 35.2836 20.5373 34.4776ZM29.5224 34.4776C29.5224 33.6418 28.8358 32.9851 28.0299 32.9851C27.2239 32.9851 26.5373 33.6716 26.5373 34.4776C26.5373 35.2836 27.2239 35.9702 28.0299 35.9702C28.8657 35.9403 29.5224 35.2836 29.5224 34.4776ZM25.0448 34.4776C25.0448 33.6418 24.3582 32.9851 23.5522 32.9851C22.7463 32.9851 22.0597 33.6716 22.0597 34.4776C22.0597 35.2836 22.7463 35.9702 23.5522 35.9702C24.3582 35.9403 25.0149 35.2836 25.0448 34.4776Z"
                  fill="#0057FF"
                />
              </svg>
            </div>
            <h6 class="font-medium mt-3">Tareo</h6>
          </div>
        </router-link>
      </div>
      <div class="xl:w-1/6 lg:w-1/4 md:w-1/2 w-full">
        <router-link
          v-if="allowModule($modules.PLANIFICACION)"
          :to="{ name: 'planning-report' }"
          class="mx-2"
        >
          <div
            class="
              p-6
              px-8
              mx-2
              rounded-md
              overflow-hidden
              shadow-lg
              hover:bg-primary
              text-primary
              hover:text-white
              welcome-card
            "
          >
            <div class="flex justify-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  opacity="0.12"
                  cx="28"
                  cy="28"
                  r="28"
                  class="w-circle"
                  fill="#0057FF"
                />
                <path
                  class="w-icon"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M27.8985 19.9332H23.008C22.3207 19.9332 21.607 19.9068 21.5806 18.9816C21.5541 18.0828 22.2414 17.977 22.9552 18.0035H32.9211C33.6349 18.0035 34.3222 18.1092 34.2958 19.008C34.2693 19.9068 33.5556 19.9597 32.8683 19.9597C31.2294 19.9332 29.5642 19.9332 27.899 19.9332H27.8985ZM27.8985 21.3606H34.2428C34.9566 21.3606 35.6439 21.4399 35.6703 22.3387C35.6968 23.2375 35.0095 23.3697 34.2957 23.3697H21.607C20.8932 23.3697 20.2059 23.2111 20.2323 22.3387C20.2588 21.4664 20.9461 21.3606 21.6598 21.3606H27.8985ZM25.8404 37.9941C26.5336 37.9912 27.2277 37.9883 27.9248 37.9883H33.952H34.1635C36.4369 37.9618 37.8644 36.5872 37.9172 34.3138V34.3137C37.9437 32.4104 37.9701 30.5071 37.9172 28.6039C37.8644 26.3305 36.4105 24.903 34.1635 24.903C30.0132 24.8765 25.8365 24.8765 21.6862 24.903C19.4657 24.903 18.0382 26.3833 18.0117 28.551C17.9941 29.8199 18 31.0887 18.0059 32.3576C18.0088 32.9921 18.0117 33.6265 18.0117 34.2609C18.0382 36.5608 19.4128 37.9618 21.6862 37.9883C23.0775 38.0059 24.457 38 25.8404 37.9941ZM26.5895 31.6033C26.7401 31.7558 26.9063 31.9241 27.1318 32.1461C27.2888 31.981 27.4416 31.8202 27.5908 31.6631C28.4211 30.7891 29.1416 30.0306 29.881 29.2912C30.2776 28.8946 30.7269 28.6567 31.2292 29.1061C31.7843 29.6084 31.5464 30.0842 31.097 30.5336C30.0397 31.5645 28.9824 32.6218 27.9251 33.6791L27.9248 33.6794C27.4226 34.1816 26.9203 34.2345 26.3916 33.7322C26.2672 33.6135 26.1404 33.496 26.0135 33.3784C25.5471 32.9461 25.0795 32.5127 24.7262 32.014C24.5147 31.7232 24.2122 31.2175 24.6469 30.7451C25.1374 30.2922 25.6123 30.6513 25.9305 30.9531C26.1992 31.208 26.3791 31.3903 26.5895 31.6033Z"
                  fill="#0057FF"
                />
              </svg>
            </div>
            <h6 class="font-medium mt-3">Planificación</h6>
          </div>
        </router-link>
      </div>
      <div class="xl:w-1/6 lg:w-1/4 md:w-1/2 w-full">
        <router-link
          v-if="allowModule($modules.PLANOS)"
          :to="{ name: 'plans-2d' }"
          class="mx-2"
        >
          <div
            class="
              p-6
              px-8
              mx-2
              rounded-md
              overflow-hidden
              shadow-lg
              hover:bg-primary
              text-primary
              hover:text-white
              welcome-card
            "
          >
            <div class="flex justify-center">
              <svg
                width="56"
                height="56"
                viewBox="0 0 56 56"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  opacity="0.12"
                  cx="28"
                  cy="28"
                  r="28"
                  fill="#0057FF"
                  class="w-circle"
                />
                <path
                  d="M39.1435 24.7857C39.3792 24.7857 39.572 24.5929 39.572 24.3571V19.4286C39.572 19.1929 39.3792 19 39.1435 19H34.2149C33.9792 19 33.7863 19.1929 33.7863 19.4286V20.9286H22.2149V19.4286C22.2149 19.1929 22.022 19 21.7863 19H16.8577C16.622 19 16.4292 19.1929 16.4292 19.4286V24.3571C16.4292 24.5929 16.622 24.7857 16.8577 24.7857H18.3577V31.2143H16.8577C16.622 31.2143 16.4292 31.4071 16.4292 31.6429V36.5714C16.4292 36.8071 16.622 37 16.8577 37H21.7863C22.022 37 22.2149 36.8071 22.2149 36.5714V35.0714H33.7863V36.5714C33.7863 36.8071 33.9792 37 34.2149 37H39.1435C39.3792 37 39.572 36.8071 39.572 36.5714V31.6429C39.572 31.4071 39.3792 31.2143 39.1435 31.2143H37.6435V24.7857H39.1435ZM35.5006 20.7143H37.8577V23.0714H35.5006V20.7143ZM18.1435 23.0714V20.7143H20.5006V23.0714H18.1435ZM20.5006 35.2857H18.1435V32.9286H20.5006V35.2857ZM37.8577 32.9286V35.2857H35.5006V32.9286H37.8577ZM35.7149 31.2143H34.2149C33.9792 31.2143 33.7863 31.4071 33.7863 31.6429V33.1429H22.2149V31.6429C22.2149 31.4071 22.022 31.2143 21.7863 31.2143H20.2863V24.7857H21.7863C22.022 24.7857 22.2149 24.5929 22.2149 24.3571V22.8571H33.7863V24.3571C33.7863 24.5929 33.9792 24.7857 34.2149 24.7857H35.7149V31.2143Z"
                  fill="#0057FF"
                  class="w-icon"
                />
              </svg>
            </div>
            <h6 class="font-medium mt-3">Planos</h6>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>
<style scoped>
.welcome-card:hover .w-circle {
  fill: rgba(255, 255, 255, 0.461);
}
.welcome-card:hover .w-icon {
  fill: white;
}
</style>
<script setup>
import { getCurrentInstance, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const app = getCurrentInstance();
const roles = app.appContext.config.globalProperties.$roles;

const getUserAuthenticated = computed(() => store.getters.getUserAuthenticated);
const getUserPermissions = computed(() => store.getters.getUserPermissions);

const allowModule = (module) => {
  return (
    getUserAuthenticated.value.type === roles.ADMIN ||
    getUserPermissions.value?.find(
      (p) => p.module === module && p.hasWebPermissions
    )
  );
};
</script>
